export default {
  cloneFromType: {
    survey: 'Inventário',
    template: 'Modelo',
  },
  createSurvey: 'Criar inventário',
  createTemplate: 'Criar modelo',
  newSurvey: 'Novo inventário',
  newSurveyFromScratch: 'Novo inventário do zero',
  newTemplate: 'Novo modelo',
  newTemplateFromScratch: 'Novo modelo do zero',
  source: {
    label: 'Origem',
    arena: 'Arena (.zip)',
    collect: 'Collect (.collect, .collect-backup, .collect-data)',
    odk: 'ODK (.xml)',
  },
  startImport: 'Iniciar importação',
  survey: 'Inventário',
  survey_other: 'Inventários',
  template: 'Modelo',
  template_other: 'Modelos',
  error: 'Erro ao criar novo inventário',
  errorMaxSurveysCountExceeded: `Erro ao criar inventário; você atingiu o número máximo de inventários que pode criar ({{maxSurveysCount}}).`,
  options: {
    includeData: 'Incluir dados',
  },
}
